<medpace-table
    [attr.data-cy]="'StudiesTable'"
    [data]="(studies$ | async) || undefined"
    title="All Studies"
    [columns]="studyColumns"
    [fieldMap]="studyColumnMap"
    [isSearching]="true"
    [includePaginator]="true"
    [ifFiltering]="false"
    [showFilters]="false"
    [defaultSorting]="{ columnName: 'sponsor', direction: 'asc' }"
    (rowClickEvent)="doClickRow($event)"
></medpace-table>
